const PageLoader = () => {
  return (
    <div id="overlayer">
      <span className="loader">
        <span className="loader-inner"></span>
      </span>
    </div>
  );
};

export default PageLoader;
